import { Checkbox } from "./ui/checkbox";
import { placeCfg } from "../lib/placeOptions";

export const PlacePicker = ({ opt, place, onChange }) => {
  const cfg = placeCfg(opt);
  const max = opt.max_qty ?? 1;
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-1.5 mt-1.5" data-testid={`place-${opt.id}`}>
      {["a", "b"].map((side) => (
        <div key={side} className="flex items-center gap-1.5 text-xs">
          <label className="flex items-center gap-1.5 cursor-pointer" data-testid={`place-${opt.id}-${side}`}>
            <Checkbox checked={place[side] > 0} onCheckedChange={(v) => onChange(opt, side, v ? 1 : 0)} data-testid={`place-${opt.id}-${side}-check`} />
            {cfg[side]}
          </label>
          {place[side] > 0 && max > 1 && (
            <select value={place[side]} onChange={(e) => onChange(opt, side, Number(e.target.value))}
              className="h-6 rounded border border-input bg-background px-1 text-xs" data-testid={`place-${opt.id}-${side}-qty`}>
              {Array.from({ length: max }, (_, i) => i + 1).map((n) => <option key={n} value={n}>{n}</option>)}
            </select>
          )}
        </div>
      ))}
    </div>
  );
};
